import { eventQBus } from "../utils/EventQBus";
import { OnTileLoad } from "../types/Tile";

const MAX_RETRIES = 2;

/**
 *
 *
 *
 *
 *
 */
function extractHtmlFragment(xhr: Response) {
  if (xhr.status !== 200 && xhr.status !== 404) {
    throw Error(`Failed to retrieve tile: ${xhr.status} ${xhr.statusText}`);
  }
  return xhr.text();
}

/**
 *
 *
 *
 *
 *
 *
 *
 */
export function insertTile(this: HTMLElement, html: string) {
  const range = document.createRange();
  /*                                 */
  /*                                                               */
  range.selectNodeContents(this);
  const fragment = range.createContextualFragment(html);

  /*           */
  range.deleteContents();
  range.insertNode(fragment);

  /*                   */
  this.classList.remove("find_tile--lazy", "js_reptile_tile--lazy");
  this.removeAttribute("data-retry-count");
}

export function insertCompleteTile(this: HTMLElement, html: string) {
  const range: Range = document.createRange();
  /*                                 */
  /*                                                               */
  range.selectNodeContents(this);
  const fragment = range.createContextualFragment(html);

  /*           */
  range.deleteContents();
  range.insertNode(fragment);

  this.setAttribute("data-loaded", "true");
}

export function fetchTile(
  href: string,
  insertTileFunc: (this: HTMLElement, html: string) => void,
  retryCount = 0,
): Promise<void> {
  const tracking = ""; /*                                   */
  return fetch(href, {
    headers: {
      /*                                                                                     */
      /*                                                                                             */
      /*                                                                               */
      "X-Find-Trackable": tracking,
    },
  })
    .then(extractHtmlFragment)
    .then(insertTileFunc)
    .catch(() => {
      if (retryCount < MAX_RETRIES) {
        return fetchTile(href, insertTileFunc, ++retryCount);
      }
    });
}

/**
 *
 */
function onLoadTile(event: OnTileLoad): void {
  const tileTarget = event.target;

  if (tileTarget) {
    const href = tileTarget.dataset["href"];

    /*                                                            */
    if (href?.includes("completeTile=true")) {
      fetchTile(href, insertCompleteTile.bind(tileTarget));
    } else if (href) {
      fetchTile(href, insertTile.bind(tileTarget));
    }
  }
}

export default function registerLazyTile() {
  eventQBus.on("ftfind.tile.load", onLoadTile);
}
